<template>
  <div>
    <div class="pnf-main-container position-relative d-flex">
      <div class="w-100 d-flex">
        <div class="pnf-left-container">
          <div class="pnf-error-message">
            <h2>404 Error:Page Not Found</h2>
            <p>It seems like the page you're looking for doesn't exist.</p>
            <span>Here are few things you can try:</span>

            <div class="pnf-check-message">
              <div class="pnf-message">
                <h6>Check the URL:</h6>
                <span>Make sure you've entered the correct URL.</span>
              </div>

              <div class="pnf-message">
                <h6>Go back:</h6>
                <span
                  >Use your browser's back button to return to the previous
                  page.
                </span>
              </div>

              <div class="pnf-message">
                <h6>Contact Us:</h6>
                <span>
                  If you believe there's an issue, feel free to
                  <span class="pnf-contact-link">contact us</span> for
                  assistance.
                </span>
              </div>
            </div>
          </div>

          <div class="pnf-vector-img position-absolute">
            <img src="../../assets/img/pagenotfound/bottomimg.svg" alt="" />
          </div>
        </div>

        <div class="pnf-right-container d-flex align-item-center">
          <div class="pnf-404-image">
            <img src="../../assets/img/pagenotfound/404.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound",
  methods: {
    Back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
/* /404 new page */

.container {
  box-shadow: 0px 4px 20px 0px #c4c4c480;
  padding: 35px;
  margin-top: 20px;
  height: calc(100vh - 145px);
  width: 95%;
  max-width: none;
  background-color: black;
}

.pnf-main-container {
  background: #ffffff;
  border: 1px solid rgba(140, 140, 140, 0.33);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
  border-radius: 8px;
  height: calc(100vh - 135px);
  top: 75px;
  margin: 30px 53px;
  padding: 120px 95px 112px 115px;
  overflow: auto;
}

.pnf-left-container {
  width: 60%;
}

.pnf-right-container {
  width: 40%;
}

.pnf-error-message {
  z-index: 2;
  position: relative;
}

.pnf-error-message h2 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 25px;
  color: #20639b;
  margin-top: -28px;
}

.pnf-error-message p {
  width: 88%;
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 25px;
  color: #000000;
  margin-bottom: 40px;
}

.pnf-error-message span {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 16px;
}

.pnf-check-message h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #3a3c40;
  margin-bottom: 0;
}

.pnf-check-message span {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #3a3c40;
}

.pnf-message {
  margin-top: 20px;
}

.pnf-message .pnf-homepage-link {
  text-decoration: underline;
  color: #20639b;
  cursor: pointer;
}

.pnf-message .pnf-contact-link {
  color: #20639b;
  text-decoration: underline;
}

.pnf-vector-img {
  top: 249px;
  left: -42px;
  z-index: 1;
}

/* 404 new page ends here*/
</style>
